import React from 'react';
import moment from 'moment';

const PostNewIcon = (props) => {
  const { postInfo, term = 7 } = props;

  const date = postInfo.created_date ? postInfo.created_date : '';
  let diffDay = moment().diff(moment(date), 'days');
  let isShowIcon = false;
  if (diffDay < term) {
    isShowIcon = true;
  }
  if (isShowIcon) {
    return (
      <img
        src="https://s.wink.co.kr/pc/images/icon_new.png"
        alt="New"
        className="new"
      />
    );
  } else {
    return null;
  }
};

export default PostNewIcon;
